import { TRAILER_BODY_CATEGORY, VIN_LENGTH } from 'common/constants';

type VehicleVinData =
  | {
      veh_vin?: string;
      veh_body_category?: string;
    }
  | undefined;

export const sanitizeVinInput = (value: string): string =>
  value.toUpperCase().replace(/[^A-Z0-9]/g, '');

export const isTrailerVehicle = (vehicleData: VehicleVinData): boolean =>
  vehicleData?.veh_body_category === TRAILER_BODY_CATEGORY;

export const isShortVin = (vin: string | undefined): boolean => {
  const vinLength = (vin ?? '').trim().length;

  return vinLength > 0 && vinLength < VIN_LENGTH;
};

// Trailers keep the exactly-17 rule until ENG-12264 gives them their own requirement.
export const shouldApplyShortVinRules = (
  isVehicleVinRequiredEnabled: boolean,
  vehicleData: VehicleVinData,
): boolean => isVehicleVinRequiredEnabled && !isTrailerVehicle(vehicleData);
